import { render, staticRenderFns } from "./RealEstateDetails.vue?vue&type=template&id=ac635674&"
import script from "./RealEstateDetails.vue?vue&type=script&lang=js&"
export * from "./RealEstateDetails.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../vue/vue2/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports